// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ToggleSection_wrapper__Ck4tr","button":"ToggleSection_button__PqpPs","image":"ToggleSection_image__oXsmB"};